import React from "react";
import Constants from "../Constants";
import Modal from "react-bootstrap/Modal";
import Carousel from "react-bootstrap/Carousel";

const ImagePreview = ({ images }) => {
  const [show, setShow] = React.useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div>
      <img
        className="img-fluid"
        alt={`Traffic camera view at ${images[0].image_name}`}
        src={Constants.baseUrl(`uploads/${images[0].image_name}`)}
      />
      <a
        className="link-dark m-2"
        href={Constants.baseUrl(`uploads/${images[0].image_name}`)}
        download
        target="_blank"
        rel="noreferrer"
        aria-label="Download image"
      >
        <i className="fa-solid fa-download" aria-hidden="true"></i>
      </a>
      <button
        className="link-dark m-2 border-0 bg-transparent"
        onClick={handleShow}
        aria-label="View image gallery"
        type="button"
      >
        <i className="far fa-search-plus" aria-hidden="true"></i>
      </button>

      <Modal
        centered
        size="xl"
        show={show}
        onHide={handleClose}
        aria-labelledby="image-gallery-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="image-gallery-title">Image Gallery</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Carousel>
            {images.map((image, index) => {
              return (
                <Carousel.Item key={index}>
                  <img
                    className="d-block w-100"
                    src={Constants.baseUrl(`uploads/${image.image_name}`)}
                    alt={`Traffic camera image ${index + 1} of ${images.length} - ${image.image_name}`}
                  />
                </Carousel.Item>
              );
            })}
          </Carousel>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ImagePreview;
